module.exports = __webpack_public_path__ + "media/images/redribbon-c1ae1468a73744f634ddbbb498696d20.png";